import { Spacing } from "@faire/web-api--source/indigofair/data/Spacing";

// This is the default item spacing in EmblaCarousel
const DEFAULT_SPACING = 16;

export const getSpacingPixels = (spacing: keyof typeof Spacing): number => {
  return spacingToNumberMap[spacing] ?? DEFAULT_SPACING;
};

// Spacing values come from https://www.figma.com/file/s7VxgVsNoO1smpdecnUYoN/Faire-Slate?type=design&node-id=4449-12646&mode=design&t=crJA1bdzBVGLE3uu-0
const spacingToNumberMap: Partial<Record<Spacing, number>> = {
  L: 24,
  R: 16,
  S: 12,
  XS: 8,
  XXS: 4,
  SPACING_NONE: 0,
  SPACING_UNKNOWN: DEFAULT_SPACING,
};
